"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
export default function LogoTicker() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      name: "Terraform",
      color: "#7B42BC",
      icon: "/icons/brands/terraform.svg"
    }, {
      name: "Kubernetes",
      color: "#326CE5",
      icon: "/icons/brands/kubernetes.svg"
    }, {
      name: "AWS",
      color: "#FF9900",
      icon: "/icons/brands/aws.svg",
      invert: true,
      restoreColor: true
    }, {
      name: "Google Cloud",
      color: "#4285F4",
      icon: "/icons/brands/gcp.svg"
    }, {
      name: "Azure",
      color: "#0078D4",
      icon: "/icons/brands/azure.svg"
    }, {
      name: "ArgoCD",
      color: "#EF7B4D",
      icon: "/icons/brands/argocd.svg",
      invert: true,
      restoreColor: true
    }, {
      name: "Vault",
      color: "#FFEC6E",
      icon: "/icons/brands/vault.svg"
    }, {
      name: "GitHub",
      color: "#ffffff",
      icon: "/icons/brands/github.svg",
      invert: true
    }, {
      name: "GitLab",
      color: "#FC6D26",
      icon: "/icons/brands/gitlab.svg"
    }, {
      name: "Prometheus",
      color: "#E6522C",
      icon: "/icons/brands/prometheus.svg"
    }, {
      name: "Datadog",
      color: "#632CA6",
      icon: "/icons/brands/datadog.svg",
      invert: true,
      restoreColor: true
    }, {
      name: "Grafana",
      color: "#F46800",
      icon: "/icons/brands/grafana.svg"
    }, {
      name: "Docker",
      color: "#2496ED",
      icon: "/icons/brands/docker.svg"
    }, {
      name: "Jenkins",
      color: "#D24939",
      icon: "/icons/brands/jenkins.svg"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const logos = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-surface-card to-transparent z-10" />;
    t2 = <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-surface-card to-transparent z-10" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="w-full bg-surface-card border-t border-border-default overflow-hidden py-6 relative z-20">{t1}{t2}<div className="flex w-max animate-marquee">{[...logos, ...logos].map(_temp)}</div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp(logo, index) {
  return <div key={`${logo.name}-${index}`} className="flex items-center gap-3 mx-8 opacity-70 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-500 cursor-default group"><div className="relative flex items-center justify-center h-9 w-auto min-w-[36px]">{logo.icon ? <div className={`relative h-full w-auto aspect-square opacity-60 group-hover:opacity-100 group-hover:grayscale-0 grayscale transition-all duration-300 filter brightness-125 hover:brightness-100 ${logo.invert ? "dark:invert" : ""} ${logo.restoreColor ? "group-hover:invert-0" : ""}`}><Image src={logo.icon} alt={logo.name} height={36} width={36} className="object-contain h-full w-auto" /></div> : <div className="flex flex-col items-center"><div className="w-3 h-3 rounded-full shadow-[0_0_10px_currentColor] opacity-60 group-hover:opacity-100 transition-opacity mb-1" style={{
          backgroundColor: logo.color
        }} /></div>}</div><span className="text-lg font-bold tracking-wide text-text-secondary group-hover:text-text-primary transition-colors">{logo.name}</span></div>;
}